import { useRouter } from 'next/router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toaster = () => {
  const { locale } = useRouter();

  return (
    <ToastContainer
      autoClose={3000}
      limit={1}
      className="toaster-container"
      position="bottom-right"
      closeOnClick
      rtl={locale === 'ar'}
    />
  );
};

export default Toaster;
